import React from 'react';
import clsx from "clsx";
import { parseDate } from '@Util/moment';
import { FOOTER_TYPE } from "@Constants/dataEnums";

const MainFooter = ({ footerType = FOOTER_TYPE.DEFAULT }) => {

    const isFlex = (footerType & FOOTER_TYPE.FLEX) !== 0;
    const isHide = (footerType & FOOTER_TYPE.HIDE) !== 0;
    const isHideBorderTop = (footerType & FOOTER_TYPE.HIDE_BORDER_TOP) !== 0;
    const isBlurredGlass = (footerType & FOOTER_TYPE.BLURRED_GLASS) !== 0;
    const isHideText = (footerType & FOOTER_TYPE.HIDE_TEXT) !== 0;

    return (
        <footer className={clsx('footer', {
            'flex-bottom': isFlex, 
            'hide': isHide, 
            'hide-border-top': isHideBorderTop,
            'blurred-glass': isBlurredGlass,
            'hide-text': isHideText,
        })}>
            <div className="container">
                <div className="copyright ban-select">
                    {`© ${parseDate(new Date(), 'YYYY')} Curves`}
                    <br />
                    <span className={'text-sm'}>可爾姿女性30分鐘高效燃脂訓練</span>
                </div>
            </div>
        </footer>
    );
};

export default MainFooter;
